import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import SectionOverview from './SectionOverview';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCareOverview } from './companyCareApi';
import { SECTION_LABELS } from './careTheme';

/**
 * Route wrapper for either clinical section's overview. Scoping comes from the
 * token and the sidebar toggle; the section decides which endpoint prefix is
 * used, and the backend will not cross between them.
 */
const CSectionOverview = ({ section, basePathSuffix }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    () => fetchCareOverview(section, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [section, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{SECTION_LABELS[section]} | Shoorah</title>
      </Helmet>
      <SectionOverview
        section={section}
        fetcher={fetcher}
        basePath={`/${slug}/${basePathSuffix}`}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

CSectionOverview.propTypes = {
  section: PropTypes.oneOf(['care', 'reproductive']).isRequired,
  basePathSuffix: PropTypes.string.isRequired
};

export const CCareOverview = () => <CSectionOverview section="care" basePathSuffix="care" />;

export const CReproductiveOverview = () => (
  <CSectionOverview section="reproductive" basePathSuffix="reproductive-health" />
);

export default CSectionOverview;
